import React from 'react';
export default class ElegantResumeSummary extends React.Component{
    render(){
        return  <div data-v-5a80631c="" className="section">
                    <div data-v-5a80631c="" className="section-headline">{this.props.title}</div>
                    <div data-v-5a80631c="" className="section-description" dangerouslySetInnerHTML={{ __html: this.props.data.description }}></div>
                </div>
    }
}